<template>
  <div
    class="flex flex-row items-center bg-white py-24 md:px-64 px-16 bg-schibsted flex items-center"
  >
    <schibsted-logo class="hidden md:block" />
    <p class="pl-0 md:pl-16 m-0 text-14 text-gray-500">
      {{ $t('honk-part-of-schibsted') }}
      <a
        class="text-14 honk-burgundy-800"
        :href="privacyDeclarationUrl"
        target="_blank"
      >
        {{ $t('read-more') }}
      </a>
    </p>
  </div>
</template>
<script setup>
  import { inject } from 'vue'
  import SchibstedLogo from './assets/SchibstedLogo.vue'
  import { configInjectionKey } from './injectionKeys.js'

  const { privacyDeclarationUrl } = inject(configInjectionKey)
</script>
<style scoped>
  .bg-schibsted {
    background: #f9f6f5;
  }
</style>
